import * as React from "react";
import { ChoiceGroup as MSChoiceGroup } from "@fluentui/react";
import { useField } from "formik";

const ChoiceGroup = (props) => {
  const [field, meta, helpers] = useField(props);

  const onChange = React.useCallback(
    (ev, option) => {
      helpers.setValue(option.key);
    },
    [helpers]
  );
  return (
    <MSChoiceGroup
      defaultSelectedKey={field.value || meta.initialValue}
      selectedKey={field.value}
      onChange={onChange}
      errorMessage={meta.touched && meta.error}
      label="Pick one"
      {...props}
    />
  );
};
export default ChoiceGroup;
